import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

import HeaderLayout from '@/components/common/CustomLayout/HeaderLayout';

import LeftSection from './LeftSection';
import RightSection from './RightSection';

import { useAppDispatch } from '@/store';
import { createNews, getNewsById, updateNews } from '@/store/news/action';
import extactUserInfo from '@/utils/user_info';
import Header from './Header';

const NewsDetail = () => {
	const { newsId } = useParams();

	const [file, setFile] = useState<File | null>(null);
	const form = useForm();
	const dispatch = useAppDispatch();

	const navigate = useNavigate();

	useEffect(() => {
		if (newsId) {
			const setNewsDetailForm = (news: News) => {
				form.setValue('title', news.title);
				form.setValue('slug', news.slug);
				form.setValue('content', news.content);
				form.setValue('venueName', news.venue.name);
				form.setValue('venueId', news.venue.id);
				form.setValue('newsStatus', news.status || 'DRAFT');
				form.setValue('showOnHome', news.show_on_home);
				form.setValue('category', news.category_code);
				form.setValue('thumbnailLink', news.thumbnail_link);
			};

			dispatch(getNewsById({ newsId, success: setNewsDetailForm }));
		} else {
			form.setValue('newsStatus', 'DRAFT');
		}
	}, [newsId]);

	const handleClick = () => {
		const user = extactUserInfo();

		const newsRequest: NewsRequest = {
			id: newsId,
			title: form.watch('title'),
			slug: form.watch('slug'),
			content: form.watch('content'),
			venue_id: form.watch('venueId'),
			category_code: form.watch('category'),
			author_user_id: user.user_id,
			show_on_home: form.watch('showOnHome') || false,
			status: form.watch('newsStatus') || 'DRAFT',
			thumbnail_link: form.watch('thumbnailLink'),
		};

		if (newsId) {
			dispatch(updateNews(newsRequest));
		} else {
			dispatch(createNews(newsRequest));
		}
		navigate('/dashboard/news');
	};

	return (
		<FormProvider {...form}>
			<HeaderLayout
				title="Write News"
				rightComponent={Header({ handleClick, form })}
			>
				<div className="flex justify-between">
					<div className="flex-[3_3_0%]">
						<LeftSection />
					</div>
					<div className="flex-[1_1_0%] bg-white border border-grey-soft ml-6">
						<RightSection file={file} setFile={setFile} />
					</div>
				</div>
			</HeaderLayout>
		</FormProvider>
	);
};

export default NewsDetail;
